/* istanbul ignore file */
import React from 'react';
import { DropDownFilter } from 'framework/list';
import AccountTypeDropdown from 'domain/sales/account/shared/input/AccountTypeDropdown';

const AccountTypeFilter = ({ source, ...props }: any) => {
  return (
    <DropDownFilter source={source} {...props}>
      <AccountTypeDropdown source={source} />
    </DropDownFilter>
  );
};

export default AccountTypeFilter;
